// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__7XXXs","main":"siteloader_main__x-84H","center":"siteloader_center__xDVvQ","middle":"siteloader_middle__MAs-J","top":"siteloader_top__O6bv0"};